import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PlayerNextFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PlayerNextFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M17.25 2v7.94L3.75 2v20l13.5-7.94V22h3V2h-3Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PlayerNextFilled;